<template>
  <div
    id="roaming-team-calendars"
  >
    <div v-if="roamingTeams.length > 0">
      <TabView
        v-model:activeIndex="index"
        lazy
      >
        <TabPanel
          v-for="roamingTeam in roamingTeams"
          :key="roamingTeam.id"
          :header="roamingTeam.name"
        >
          <RoamingTeamCalendar
            :roaming-team="roamingTeam"
            :appointments="selectedRoamingTeamAppointments"
            :control-duration="controlDuration"
            @create-appointment="onCreateAppointment"
            @remove-appointment="onRemoveAppointment"
          />
        </TabPanel>
      </TabView>
    </div>
    <div v-else>
      <p>{{ $t('appointmentPage.noRoamingTeam') }}</p>
    </div>
  </div>
</template>

<script>
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import RoamingTeamCalendar from "@/components/appointments/RoamingTeamCalendar.vue";
import {reactive} from "vue";
import useRoamingTeamFilter from "@/composables/filters/useRoamingTeamFilter";

export default {
  name: 'RoamingTeamCalendarsTabView',
  components: {RoamingTeamCalendar, TabView, TabPanel},
  props: {
    controlDuration: {
      type: Number,
      required: true
    },
    modelValue: {
      type: Array,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup() {
    const roamingTeamFilter = reactive(useRoamingTeamFilter());
    roamingTeamFilter.pageable.size = 1000;
    roamingTeamFilter.filters.enabled.value = true;
    return { roamingTeamFilter };
  },
  data() {
    return {
      roamingTeams: [],
      index: 0,
    }
  },
  computed: {
    appointments: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    selectedRoamingTeam() {
      return this.roamingTeams[this.index]
    },
    selectedRoamingTeamAppointments() {
      return this.appointments.filter(appointment => {
        return appointment.roamingTeam.id === this.selectedRoamingTeam.id;
      });
    }
  },
  mounted() {
    this.getRoamingTeams();
  },
  methods: {
    async getRoamingTeams() {
      this.roamingTeams = (await this.$roamingTeamService.fetchRoamingTeamsPagingAndSorting(this.roamingTeamFilter.getQueryParams())).content;
    },
    onCreateAppointment(createdAppointment) {
      const appointments = [...this.appointments]
      appointments.push(createdAppointment)
      this.appointments = appointments
    },
    onRemoveAppointment(appointmentToRemove) {
      this.appointments = this.appointments.filter(appointment => {
        return appointment !== appointmentToRemove;
      });
    },
  }
}
</script>

<style lang="scss" scoped>
#roaming-team-calendars {
  border: 2px solid #dee2e6;
}

::v-deep(.p-tabview ul.p-tabview-nav) {
  background-color: #fff;
  flex-flow: row wrap;
}
</style>

